/**
 * @param fns functions of the same signature to call. Doesn't allow a return type currently since
 * composing return types would be weird and isn't really what we need this for here.
 */
export function callAllHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return function handle() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    fns.forEach(fn => {
      fn && fn(...args);
    });
  };
}
//# sourceMappingURL=callAllHandlers.js.map